import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { tap } from 'rxjs/operators';
import { Api } from 'src/app/shared/constants/api';
import { DataService } from 'src/app/shared/services/data.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { IBank, IBankCriteria } from '../bank.interface';
import { Subscription } from 'rxjs';
import { Message } from 'src/app/shared/constants/message';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { IPermissionWithShow } from 'src/app/shared/interface';
import * as _ from 'underscore';

@Component({
    selector: 'app-bank-list',
    templateUrl: './bank-list.component.html',
    styleUrls: ['./bank-list.component.less'],
    standalone: false
})
export class BankListComponent implements OnInit,AfterViewInit, OnDestroy {

  constructor(private utilityService:UtilityService, private logger:NGXLogger,private router:Router,
              private activatedRoute:ActivatedRoute,private service:DataService, private formBuilder:FormBuilder,
              private permissionService:PermissionService) { }

  bankListDataSource=new MatTableDataSource<IBank>();
  bankColumns:string[]=['code','name','branchName','accountNo','action'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator:MatPaginator;
  totalBankRecords;
  criteria: IBankCriteria = {};
  bankListForm:FormGroup;
  pageSizeOptions:Array<number>=this.utilityService.getPageSizeOptions();
	subscription = new Subscription();
  addPermission : boolean = false;
  editPermission : boolean = false;
  viewPermission : boolean = false;
  
  ngOnInit(): void {
    this.checkAllPermission();
    this.initializeForm();
    this.setAccountNoChangeEvent();
    this.setBankCodeChangeEvent();
    this.setBankNameChangeEvent();
    this.setBranchNameChangeEvent();
  }

  ngAfterViewInit() {
    this.criteria.page = 0;
    this.criteria.size = 20;
    this.bankListDataSource.paginator = this.paginator;
    this.bankListDataSource.sort = this.sort;
    this.paginator.page.pipe(tap(() => this.getBankList())).subscribe();
    this.getBankList();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  initializeForm() {
    this.bankListForm=this.formBuilder.group({
      code:[],
      name:[],
      branchName:[],
      accountNo:[]
    })
  }

 
  sortData(event){
    this.logger.info('sort data called ', event);
    this.criteria.sort = [event.active, event.direction];
    this.getBankList(true);
  }

  private setBankCodeChangeEvent() {
    this.subscription = this.bankListForm.get('code').valueChanges.subscribe(bankCode => {
      this.logger.info('code value', bankCode);
      this.criteria.code = bankCode;
      this.getBankList(true);
    });
  }

  private setAccountNoChangeEvent() {
    const sub = this.bankListForm.get('accountNo').valueChanges.subscribe(accountNo => {
      this.logger.info('Account No value', accountNo);
      this.criteria.accountNo = accountNo;
      this.getBankList();
    });
    this.subscription.add(sub);
  }

  private setBranchNameChangeEvent() {
    const sub = this.bankListForm.get('branchName').valueChanges.subscribe(branchName => {
      this.logger.info('Branch Name', branchName);
      this.criteria.branchName = branchName;
      this.getBankList();
    });
    this.subscription.add(sub);
  }

  private setBankNameChangeEvent() {
    const sub = this.bankListForm.get('name').valueChanges.subscribe(bankName => {
      this.logger.info('Bank Name', bankName);
      this.criteria.name = bankName;
      this.getBankList();
    });
    this.subscription.add(sub);
  }


  openBankForm(bankId?:number) {
    this.logger.info("BankId",bankId);
    if(!bankId){
      this.addPermission ? this.router.navigate(["add"],{relativeTo:this.activatedRoute}) :
        this.utilityService.notifier(Message.ADD_PERMISSION_WARNING,"warning");
    } else {
      this.logger.info("Editing Bank Details");
      this.editPermission ? this.router.navigate(["edit/"+bankId],{relativeTo:this.activatedRoute}) :
        this.utilityService.notifier(Message.EDIT_PERMISSION_WARNING,"warning");
    }
  }

  getBankList(resetPageIndex: boolean =false){
    if (resetPageIndex) {
      this.paginator.pageIndex = 0;
    }
    if(this.viewPermission){
      this.criteria.page=this.paginator.pageIndex;
      this.criteria.size=this.paginator.pageSize;
      this.service.get(Api.BANK, this.criteria).subscribe(res => {
        if (res && res.contents) {
          if(res.contents.length==0){
            this.utilityService.notifier('No Records Found','info');
          }
          this.logger.info('Bank list res ', res)
          this.bankListDataSource = res.contents;
          this.totalBankRecords = res.totalRecords;
          if (this.paginator.pageIndex >= Math.ceil(res.totalRecords / this.paginator.pageSize)) {
            this.paginator.pageIndex = 0;
          }
        }
      }); 
    } else
    this.utilityService.notifier(Message.VIEW_PERMISSION_WARNING,"warning");
  }

  public checkAllPermission(){
    const permissionCodes=[PermissionKey.BANK_MODULE_ADD_PERMISSION,PermissionKey.BANK_MODULE_EDIT_PERMISSION,PermissionKey.BANK_MODULE_VIEW_PERMISSION];
    const permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.BANK_MODULE);
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.BANK_MODULE_ADD_PERMISSION})?.show?true:false;
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.BANK_MODULE_EDIT_PERMISSION})?.show?true:false;
    this.viewPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.BANK_MODULE_VIEW_PERMISSION})?.show?true:false;
  }
 
}
